export const MIN_LOADING_SPINE_MS = 3200;

export const getRemainingLoaderDelay = (
  startedAt: number,
  minimumDuration = MIN_LOADING_SPINE_MS,
) => Math.max(0, minimumDuration - (Date.now() - startedAt));
